/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from 'react';
import {FormattedMessage} from 'react-intl';
import moment from 'moment';
import {Button} from 'react-bootstrap';
import {toAbsoluteUrl} from '../../../../_metronic/_helpers';
import Empty from './Empty';
import axios from "axios";
import commonJSON from '../../../../config/common.json';
import mime from "mime-types";
import {downloadFile} from '../../../../utils';


export default function ListFileVersions({
                                             data = [],
                                             className,
                                             fileName,
                                             id,
                                             fileExtension,
                                         }) {

    const mapFileVersions = (data) => {

        const getFileVersionById = () => {
            let url = `${commonJSON.base_URL}/files/getFileByVersion`;
            const requestFile = {};
            requestFile.uniqueId = id;
            requestFile.versionId = data.VersionId;
            axios.post(url, requestFile, {
                headers:
                    {
                        "Content-Type": "application/json",
                        "accessToken": "blablabla"
                    },
            })
                .then((response) => {
                    const versionName = `${fileName}.${fileExtension}`;
                    const contentType = mime.lookup(fileExtension);

                    try {
                        downloadFile(`data:${contentType};base64,${response.data.data}`, versionName, contentType);
                    } catch (exc) {
                        console.error("Save Blob method failed with the following exception.");
                        console.error(exc);
                    }
                })
                .catch((error) => {
                    console.error(`Error: + ${error}`);
                    error.clientMessage = "Can't get file!";
                });
        };

        return (
            <div className={`mb-2 files-list ${className}`}>
                <div className="font-weight-bolder font-size-sm ml-0" dir="ltr">
                    {moment(data.LastModified).format('DD[/]MM[/]YYYY[ - ]HH[:]mm')}
                </div>
                <div className="font-size-sm ml-0">
                    {data.IsLatest}
                </div>
                <div className="font-size-sm ml-0" dir="ltr">
                    {data.Size}
                </div>
                <div className="font-size-sm d-flex align-items-center justify-content-center">
                    <Button
                        variant="outline-primary"
                        className="d-flex align-items-center justify-content-between m-0 custom-button-primary"
                        onClick={getFileVersionById}
                    >
                        <img
                            src={toAbsoluteUrl("/media/svg/Download-blue.svg")}
                            alt="download"
                        />
                    </Button>
                </div>
            </div>
        );
    };

    return (
        <>
            <div className={`card card-custom w-100`}>
                <div className="card-header border-0 justify-content-start align-items-center flex-nowrap pt-15">
                    <div className="d-flex">
                        <img
                          src={toAbsoluteUrl("/media/svg/Selected-file-blue.svg")}
                          className="mr-3"
                          alt="file icon"
                        />
                        <h3 className="card-title font-weight-bolder text-dark">
                            <FormattedMessage
                                id="userDetails-listFileVersions-header"
                                defaultMessage="Files versions"
                            />
                        </h3>
                    </div>
                    <h5 className="mb-0 ml-5 align-items-center">{fileName}</h5>
                </div>
                <div className="card-body pt-2">
                    {
                        (data.length === 0)
                            ? <Empty/>
                            : (
                                <>
                                    <div className="files-list mb-3">
                                        <div className="font-weight-bolder">
                                            <FormattedMessage
                                                id="userDetails-listFileVersions-column-date"
                                                defaultMessage="Date"
                                            />
                                        </div>
                                        <div className="font-weight-bolder">
                                            <FormattedMessage
                                                id="userDetails-listFileVersions-column-lastVersion"
                                                defaultMessage="Last version"
                                            />
                                        </div>
                                        <div className="font-weight-bolder">
                                            <FormattedMessage
                                                id="userDetails-listFileVersions-column-size"
                                                defaultMessage="Size"
                                            />
                                        </div>
                                        <div className="font-weight-bolder">
                                            <FormattedMessage
                                                id="userDetails-listFileVersions-column-download"
                                                defaultMessage="Download"
                                            />
                                        </div>
                                    </div>
                                    {data.map(mapFileVersions)}
                                </>
                            )
                    }
                </div>
            </div>
        </>
    );
}
